import { Component, Input, Output, OnInit, EventEmitter, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Select } from '@ngxs/store';
import { FormlyFieldConfig, FormlyFormOptions } from '@ngx-formly/core';
import { Contact } from 'app/models/dto/contact.model';
import { ContactFormFields } from '../edit-contact-dialog/contact.formly-fields';
import { EventBusService } from 'app/modules/shared/services/event-bus.service';
import { take, takeUntil } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';
import { LocaleSettingService } from 'app/services/i18n/locale-setting.service';
import { LenderUserState } from 'app/store/lender-user/lender-user/lender-user.state';
import { LenderUser } from 'app/models/dto/lender-user.model';
import { NonOwnerPersonnel } from 'app/models/dto/non-owner-personnel.model';

@Component({
  selector: 'app-add-personnel',
  templateUrl: './add-personnel.component.html',
  styleUrls: ['./add-personnel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AddPersonnelComponent implements OnInit, OnDestroy {

  @Select(LenderUserState.lenderUser) lenderUser$: Observable<LenderUser>;
  @Input() contact: Contact;
  @Input() nonOwnerPersonnel: NonOwnerPersonnel;
  @Input() isAnOwner: boolean;
  @Input() contactsSaving: { saving: boolean, contactId: number | string };
  @Input() nopSaving: { saving: boolean, nonOwnerPersonnelId: number | string };
  @Output() cancel = new EventEmitter();
  @Output() saveContact = new EventEmitter<any>();
  @Output() saveNonOwnerPersonnel = new EventEmitter<any>();
  @Output() switchOwnershipType = new EventEmitter<any>();

  confirmDelete = false;
  isBusiness = false;
  contactFormFields;
  model: any;
  form = new UntypedFormGroup({});
  fields: FormlyFieldConfig[];
  options: FormlyFormOptions = {};
  destroyed$ = new Subject<boolean>();
  canSeeCountrySelect: boolean;

  constructor(
    private eventBusService: EventBusService,
    private localeSettingService: LocaleSettingService
  ) { }

  ngOnInit(): void {
    this.lenderUser$.pipe(take(1), takeUntil(this.destroyed$)).subscribe((user) => {
      this.canSeeCountrySelect = user.permissions.includes('seeCountrySelect');
    });
    this.contactFormFields = new ContactFormFields(this.canSeeCountrySelect, this.localeSettingService);
    this.formatModel();
    // this.isBusiness = this.contact.isBusiness;
    this.toggleFormFields();
    this.options = {
      formState: {
        mainModel: this.model
      }
    };
    this.eventBusService.subscribe(this.eventBusService.types.ContactDialogClosedEvent)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(() => this.cancelEdit());
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
  }

  formatModel() {
    this.model = !!this.contact ? this.contact : this.nonOwnerPersonnel;

    this.model.mobilePhoneModel = {
      phone: null,
      countryCode: this.localeSettingService.getDefaultLocalePhoneCode()
    };
    this.model.workPhoneModel = {
      phone: null,
      countryCode: this.localeSettingService.getDefaultLocalePhoneCode()
    };

  }

  toggleFormFields() {
    this.fields = this.contactFormFields.contactFields(this.isBusiness, this.isAnOwner);
  }

  // toggleIsBusiness() {
  //   this.isBusiness = !this.isBusiness;
  //   this.toggleFormFields();
  // }

  toggleIsAnOwner() {
    this.isAnOwner = !this.isAnOwner;
    this.toggleFormFields();
    this.switchOwnershipType.emit(this.isAnOwner);
  }

  cancelEdit() {
    if (this.options.resetModel) {
      this.options.resetModel();
    }
    this.cancel.emit();
  }

  save() {
    // if (typeof this.isBusiness === 'boolean') {
    //   this.model.isBusiness = this.isBusiness;
    // }
    this.model.workPhone = this.model.workPhoneModel?.phone;
    this.model.workPhoneCountryCodeId = this.model.workPhoneModel?.countryCode;
    this.model.mobilePhone = this.model.mobilePhoneModel?.phone;
    this.model.mobilePhoneCountryCodeId = this.model.mobilePhoneModel?.countryCode;
    if (this.isAnOwner && !!this.contact) {
      this.checkSaveSsn();
      this.saveContact.emit(this.model);
    } else if (!this.isAnOwner && !!this.nonOwnerPersonnel) {
      this.saveNonOwnerPersonnel.emit(this.model);
    }
  }

  checkSaveSsn() {
    if (
      this.model.ssnGuarded
      && /^\d+$/.test(this.model.ssnGuarded.toString())
      && this.model.ssnGuarded.toString().substr(0, 5) !== '00000'
    ) {
      this.model.ssn = this.model.ssnGuarded;
      delete this.model.ssnGuarded;
    }
  }

  showSpinner() {
    return (
      (this.nopSaving.saving && this.nopSaving.nonOwnerPersonnelId === 'new')
      || (this.contactsSaving.saving && this.contactsSaving.contactId === 'new')
    );
  }

  somethingIsSaving() {
    return (
      this.nopSaving.saving || this.contactsSaving.saving
    );
  }

}
